module.exports = "<vrm-header/>\n\n<div ui-view=\"body\"></div>\n";